import { render, staticRenderFns } from "./BillingRule.yaml?vue&type=template&id=78871261&component"
import script from "./BillingRule.yaml?vue&type=script&lang=ts&component"
export * from "./BillingRule.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports